import React from "react";

function BS4_Certificate() {
  return (
    <div>
      <h1>BS4_Certificate Component</h1>
      <p>This is the BS4_Certificate tutorial page content.</p>
    </div>
  );
}

export default BS4_Certificate;
